import { createListFilters } from 'app/components'
import { GrupoList } from './_models'

export type GruposFilters = {
  /** Nome ou descrição do perfil (busca parcial, sem diferenciar acentos/maiúsculas). */
  nome: string
}

export const { ListFiltersProvider, useListFilters } = createListFilters<GruposFilters>({
  nome: '',
})

const normalizar = (texto?: string) =>
  (texto ?? '')
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase()

/**
 * O endpoint de perfis devolve a lista inteira (sem paginação), então a busca e a ordem por
 * nome são feitas aqui — a barra de filtros (contagem) e a tabela usam o mesmo resultado.
 */
export const filtrarGrupos = (grupos: GrupoList[] = [], { nome }: GruposFilters) => {
  const termo = normalizar(nome.trim())
  return grupos
    .filter(
      (grupo) =>
        !termo ||
        normalizar(grupo.nome).includes(termo) ||
        normalizar(grupo.descricao).includes(termo)
    )
    .sort((a, b) => (a.nome ?? '').localeCompare(b.nome ?? '', 'pt-BR'))
}
